import { request } from "./request";

// 账号密码登录
export const login = (params) => {
    return request(
        "/off/user/login",
        params,
    );
};

// 手机号登记/注册登录
export const logins = (params) => {
    return request(
        "/off/user/phoneLoginOrRegister",
        params,
    );
};

// 获取banner
export const getBanner = (params) => {
    return request(
        "/off/index/getBanner",
        { params: params },
        true,
        "get"
    );
};

// 获取列表
export const getGamesItem = (params) => {
    return request(
        "/off/index/getGamesItem",
        { params: params },
        true,
        "get"
    );
};

// 获取下载链接(单包)
export const getGamesForDownLoad = (params) => {
    return request(
        "/off/index/getGamesForDownLoad",
        { params: params },
        true,
        "get"
    );
};

export const openGame = (params) => {
    return request(
        "/off/user/openGame",
        params,
    );
};


export const getUserGames = (params) => {
    return request(
        "/off/user/getUserGames",
        params,
    );
};

export const userReceiveGamesGift = (params) => {
    return request(
        "/off/user/userReceiveGamesGift",
        params,
    );
};
export const getUserInfo = () => {
    return request(
        "/off/user/getUserInfo",
        // params,
    );
};

export const getChargeList = (params) => {
    return request(
        "/off/charge/getChargeList",
        { params: params },
        true,
        "get"
    );
};

export const createOrder = (params) => {
    return request(
        "/off/charge/createOrder",
        params,
    );
};

// 官网平台币创建订单
export const createCoinOrder = (params) => {
    return request(
        "/off/charge/createCoinOrder",
        params,
    );
};

export const pointExchangeCoin = (params) => {
    return request(
        "/off/charge/pointExchangeCoin",
        params,
    );
};

export const editPassword = (params) => {
    return request(
        "/off/user/editPassword",
        params,
    );
};
export const editNickName = (params) => {
    return request(
        "/off/user/editNickName",
        params,
    );
};
export const bindPhoneNum = (params) => {
    return request(
        "/off/user/bindPhoneNum",
        params,
    );
};


export const getVipList = (params) => {
    return request(
        "/off/charge/getVipList",
        { params: params },
        true,
        "get"
    );
};
// 官网vip创建订单
export const createVipOrder = (params) => {
    return request(
        "/off/charge/createVipOrder",
        params,
    );
};
// 获取appid和apk地址
export const getSystemInfo = (params) => {
    return request(
        "/off/index/getSystemInfo",
        { params: params },
        true,
        "get"
    );
};


export const getUserRecords = (params) => {
    return request(
        "/off/user/getUserRecords",
        params,
    );
};



// 签到
export const signIn = (params) => {
    return request(
        "/off/task/signIn",
        params,
    );
};

export const getSignInfo = (params) => {
    return request(
        "/off/task/getSignInfo",
        params,
    );
};

export const getBaseInfo = (params) => {
    return request(
        "/off/task/getBaseInfo",
        { params: params },
        true,
        "get"
    );
};
export const getTaskList = (params) => {
    return request(
        "/off/task/list",
        { params: params },
        true,
        "get"
    );
};
export const getReceiveAward = (params) => {
    return request(
        "/off/task/receiveAward",
        { params: params },
        true,
        "get"
    );
};

// 大奖
export const exchangGift = (params) => {
    return request(
        "/off/charge/exchangGift",
        params,
    );
};

export const exchangGiftCheck = (params) => {
    return request(
        "/off/charge/exchangGiftCheck",
        params,
    );
};

// h5账号密码登录
export const accountNumberLogin = (params) => {
    return request(
        "/off/user/v1/accountNumberLoginOneGame",
        params,
    );
};
// 发送短信
export const sendSmsCode = (params) => {
    return request(
        "/common/sendSmsCode",
        params,
    );
};
// h5手机号登录
export const phoneLogin = (params) => {
    return request(
        "/off/h5/v1/phoneLogin",
        params,
    );
};
// h5手机号注册并登录
export const phoneRegister = (params) => {
    return request(
        "/off/h5/v1/phoneRegister",
        params,
    );
};
// app手机号注册并登录
export const phoneNumRegister = (params) => {
    return request(
        "/off/user/phoneNumRegister",
        params,
    );
};
// 新支付
export const newHtmlPay = (params) => {
    return request(
        "/off/user/wxAuthorization",
        params,
    );
};
// 二维码支付(游戏外的)
export const newPcPay = (params) => {
    return request(
        "/off/charge/qrcodeOrderPay",
        params,
    );
};
// 二维码支付(游戏内的)
export const newPcGamePay = (params) => {
    return request(
        "/applets/h5/v1/order/qrCodePay",
        params,
    );
};
// 实名认证
export const identityAuthentication = (params) => {
    return request(
        "/off/user/realNameAuthentication",
        params,
    );
};
// 获取游戏token
export const getGameAccount = (params) => {
    return request(
        "/off/user/getGameAccount",
        params,
    );
};
// 获取临时上传token
export const ossToken = (params) => {
    return request(
        "/common/ossToken",
        { params: params },
        true,
        "get"
    );
};
// 创建红包卡券订单
export const createRedOrder = (params) => {
    return request(
        "/off/charge/createDailyRedenvelopeOrder",
        params,
    );
};
// 每日领取红包
export const getCoupon = (params) => {
    return request(
        "/off/redPacket/getCoupon",
        params,
    );
};
// 累计领取红包
export const getThirtyCoupon = (params) => {
    return request(
        "/off/redPacket/getThirtyCoupon",
        params,
    );
};
// 获取卡卷列表
export const getCoupons = (params) => {
    return request(
        "/off/coupon/getCoupons",
        { params: params },
        true,
        "get"
    );
};
// 获取金刚区列表(弃)
export const getMenus = (params) => {
    return request(
        "/off/index/getMenus",
        { params: params },
        true,
        "get"
    );
};
// 获取金刚区列表
export const getMenusNew = (params) => {
    return request(
        "/off/index/getMenusNew",
        { params: params },
        true,
        "get"
    );
};
// 点击金刚区红点
export const clickMenus = (params) => {
    return request(
        "/off/index/clickMenus",
        { params: params },
        true,
        "get"
    );
};
// 游戏内-平台币支付-优惠卷
export const getBestCouponForCoinpay = (params) => {
    return request(
        "/off/charge/getBestCouponForCoinpay",
        params,
    );
};
// 游戏内-平台币支付-优惠卷校验
export const checkCouponForCoinpay = (params) => {
    return request(
        "/off/charge/checkCouponForCoinpay",
        params,
    );
};
// 游戏内-平台币支付-优惠卷列表
export const getCouponForCoinpays = (params) => {
    return request(
        "/off/charge/getCouponForCoinpays",
        params,
    );
};
// 领取新人好礼
export const receiveIndexActivity = (params) => {
    return request(
        "/off/user/receiveIndexActivity",
        params,
    );
};
// 获取奖项列表
export const getDrawInfo = (params) => {
    return request(
        "/off/turntable/getDrawInfo",
        { params: params },
        true,
        "get"
    );
};
// 抽奖规则和记录
export const getBaseInfo2 = (params) => {
    return request(
        "/off/turntable/getBaseInfo",
        { params: params },
        true,
        "get"
    );
};
// 抽奖前校验
export const drawCheck = (params) => {
    return request(
        "/off/turntable/drawCheck",
        params,
    );
};
// 抽奖
export const draw = (params) => {
    return request(
        "/off/turntable/draw",
        params,
    );
};
// 中奖记录
export const getRecordList = (params) => {
    return request(
        "/off/turntable/getRecordList",
        { params: params },
        true,
        "get"
    );
};
// 头像列表
export const getAvatars = (params) => {
    return request(
        "/off/user/getAvatars",
        { params: params },
        true,
        "get"
    );
};
// 更换头像
export const editAvatar = (params) => {
    return request(
        "/off/user/editAvatar",
        params,
    );
};
// 一周年庆礼包列表
export const getCelebrationList = (params) => {
    return request(
        "/off/charge/getCelebrationList",
        { params: params },
        true,
        "get"
    );
};
// 周年庆创建订单
export const createCelebrationOrder = (params) => {
    return request(
        "/off/charge/createCelebrationOrder",
        params,
    );
};
// 国庆礼包列表
export const getNationalDayList = (params) => {
    return request(
        "/off/charge/getNationalDayList",
        { params: params },
        true,
        "get"
    );
};
// 国庆创建订单
export const createNationalDayOrder = (params) => {
    return request(
        "/off/charge/createNationalDayOrder",
        params,
    );
};
// 更换手机号二次验证
export const checkPhoneNum = (params) => {
    return request(
        "/off/user/checkPhoneNum",
        params,
    );
};
// 获取福利列表
export const getBenefitList = (params) => {
    return request(
        "/off/gameGift/getList",
        { params: params },
        true,
        "get"
    );
};
// 领取礼包功能
export const getGift = (params) => {
    return request(
        "/off/gameGift/getGift",
        params,
    );
};
// 双十一礼包列表
export const getDoubleElevenList = (params) => {
    return request(
        "/off/charge/getDoubleElevenList",
        { params: params },
        true,
        "get"
    );
};
// 国庆创建订单
export const createDoubleElevenOrder = (params) => {
    return request(
        "/off/charge/createDoubleElevenOrder",
        params,
    );
};